import React, { useCallback, useEffect, useState } from "react";

import { ICountdownTimer } from "../../../models/countdown-timer.interfaces";
import { CountdownTimer as Component } from "../component/CountdownTimer";

interface IProps {
    timerData: ICountdownTimer[];
    timersExpiredPromo: string;
    onTimerReady?: () => void;
}

export const CountdownTimer = ({
    timerData,
    timersExpiredPromo,
    onTimerReady,
}: IProps): React.ReactNode => {
    const [timers, setTimers] = useState<ICountdownTimer[]>([]);
    const [currentTimer, setCurrentTimer] = useState<ICountdownTimer | null>(
        null,
    );

    const getCurrentTimer = useCallback(
        (timersList: ICountdownTimer[]) => {
            if (timersList.length === 0) {
                setCurrentTimer(null);
                return;
            }

            const now = new Date().getTime();
            const testStart = Date.parse(timersList[0].start_date);
            const testEnd = Date.parse(timersList[0].end_date);
            if (testStart <= now && testEnd >= now) {
                setCurrentTimer(timersList[0]);
                if (onTimerReady) onTimerReady();
            } else {
                const remainingTimers = timersList.slice(1);
                setTimers(remainingTimers);
                getCurrentTimer(remainingTimers);
            }
        },
        [onTimerReady],
    );

    useEffect(() => {
        setTimers(timerData);
        getCurrentTimer(timerData);
    }, [timerData, getCurrentTimer]);

    const handleTimerExpired = useCallback(() => {
        getCurrentTimer(timers);
    }, [timers, getCurrentTimer]);

    const renderCountdownTimer = (): React.JSX.Element | null => {
        if (!currentTimer) {
            if (timersExpiredPromo === "") {
                return null;
            }

            return (
                <div
                    dangerouslySetInnerHTML={{
                        __html: timersExpiredPromo,
                    }}
                ></div>
            );
        }

        return (
            <Component
                currentTimer={currentTimer}
                onTimerExpired={handleTimerExpired}
            />
        );
    };

    return <div>{renderCountdownTimer()}</div>;
};
